<template>
  <nuxt-link
    :to="`/events/${event.slug}`"
    class="card"
    :class="{ 'vertical-layout': verticalLayout }"
    @click="trackEvent"
  >
    <div class="card-image-column">
      <div class="card-image-wrapper">
        <img
          v-if="eventImage"
          class="card-image"
          :src="eventImage"
          alt="best-practice"
          loading="lazy"
        />
        <NuxtPicture
          v-else
          class="card-image"
          src="/images/events-page/placeholder.png"
          alt="placeholder"
          lazy
        />
      </div>
      <div class="card-tags">
        <span
          v-if="eventTag"
          class="card-white-tag"
        >
          {{ eventTag }}
        </span>
        <span
          v-if="event.private"
          class="card-purple-tag"
        >
          <NuxtImg
            class="logo-symbol"
            src="/images/events-page/hero/logo-symbol.svg"
            alt="logo-symbol"
            lazy
          />
          Members only
        </span>
      </div>
    </div>
    <div class="card-content">
      <div>
        <div class="date">
          <NuxtImg
            class="date-icon"
            src="/images/events-page/hero/date-icon.svg"
            alt="date-icon"
            lazy
          />
          <span class="day">{{ event.event_date }}</span>
          <span class="hour">· {{ event.event_hour }} CET</span>
        </div>
        <h1 class="card-content-title">
          {{ event.title }}
        </h1>
        <div
          v-if="event.speaker !== null"
          class="author"
        >
          <img
            v-if="speakerImage"
            class="author-image"
            :src="speakerImage"
            alt="author"
          />
          <div class="author-info">
            <span class="author-name">
              {{ event.speaker?.name }}
            </span>
            <span class="author-role">{{ event.speaker?.title }}</span>
          </div>
        </div>
      </div>
      <span class="watch-video">
        <ReadMore
          :show="true"
          :text="pastEvent ? 'WATCH NOW' : 'LEARN MORE'"
        />
      </span>
    </div>
  </nuxt-link>
</template>

<script>
import ReadMore from '~/components/Common/ReadMore/ReadMore.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  components: {
    ReadMore,
  },
  props: {
    event: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    verticalLayout: {
      type: Boolean,
      default: false,
    },
    pastEvent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    eventTag() {
      return this.event.tags?.length ? this.event.tags[0].title : false;
    },
    eventImage() {
      return this.event.header_image
        ? cloudinaryImage({ imagePath: this.event.header_image, width: 700 })
        : null;
    },
    speakerImage() {
      return this.event.speaker?.image
        ? cloudinaryImage({ imagePath: this.event.speaker.image, width: 100 })
        : false;
    },
  },
  methods: {
    trackEvent() {
      this.$analytics.track('CTA Clicked', {
        cta_name: this.verticalLayout ? 'Learn more' : 'Watch now',
        page_name: 'Homepage_Events',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './EventCard.scss';
</style>
